import { actionMenuStrings } from '../data/static/strings'
import { RootStore } from '../data/store'
import { updateEndDateTimeInRequest } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const exportFile = (tokens: any, reqBody: any, isFromVault: boolean = false, label?: string) => {
  console.log('label', label)
  const dateLabel = isFromVault
    ? RootStore.tokenizationRequests.txnsSelectedDate.dateLabel
    : RootStore.transactions.selectedDateInfo.dateLabel
  const isCustomRange = dateLabel === actionMenuStrings.customDate || dateLabel === actionMenuStrings.yesterday

  return fetch(`${sitConfig(tokens).baseUrl}${APIEndPoints.getDownloadTxnsRefundsReport}`, {
    method: 'POST',
    headers: sitConfig(tokens).headers,
    body: JSON.stringify(isCustomRange ? reqBody : updateEndDateTimeInRequest(reqBody)),
  })
}

export { exportFile }
